import React from "react";

export const PAYPAL_OPTIONS = (clientId) => ({
  clientId, currency: "EUR", intent: "capture", components: "buttons", enableFunding: "paylater",
});

export const PayIn4 = ({ amount, className = "", testid = "pay-in-4" }) => {
  const eligible = amount == null || (amount >= 30 && amount <= 2000);
  if (!eligible) return null;
  const part = amount ? (Math.round((amount / 4) * 100) / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" }) : null;
  return (
    <div data-testid={testid} className={`inline-flex items-center gap-2 rounded-2xl border border-[#0070BA]/25 bg-[#F2F8FD] px-3.5 py-1.5 text-xs text-[#003087] ${className}`}>
      <span className="font-extrabold italic tracking-tight"><span className="text-[#003087]">Pay</span><span className="text-[#0070BA]">Pal</span></span>
      <span>
        Payez en <strong>4X sans frais</strong>{part ? <> : <strong>4 × {part}</strong></> : ""}
        <span className="text-[#003087]/60"> · sous réserve d'acceptation</span>
      </span>
    </div>
  );
};

export const KlarnaPay3 = ({ amount, className = "", testid = "klarna-pay-3" }) => {
  const eligible = amount == null || (amount >= 35 && amount <= 1500);
  if (!eligible) return null;
  const part = amount ? (Math.round((amount / 3) * 100) / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" }) : null;
  return (
    <div data-testid={testid} className={`inline-flex items-center gap-2 rounded-2xl border border-[#FFA8CD] bg-[#FFF0F6] px-3.5 py-1.5 text-xs text-[#17120F] ${className}`}>
      <span className="rounded-md bg-[#FFA8CD] px-1.5 py-0.5 font-extrabold tracking-tight">Klarna.</span>
      <span>
        <strong>3X sans frais</strong>{part ? <> : <strong>3 × {part}</strong></> : ""}
        <span className="text-[#17120F]/60"> · sous réserve d'acceptation</span>
      </span>
    </div>
  );
};

export const SplitPayBadges = ({ amount, className = "", testid = "split-pay" }) => (
  <div data-testid={testid} className={`flex flex-wrap gap-2 ${className}`}>
    <PayIn4 amount={amount} testid={`${testid}-paypal`} />
    <KlarnaPay3 amount={amount} testid={`${testid}-klarna`} />
  </div>
);
